import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "sonner";
import { AuthProvider } from "./lib/auth-context";
import { ConfirmationDialogProvider } from "./lib/confirmation-dialog";
import { Theme, ThemeProvider } from "./lib/theme-provider";
// Import the router
import { router } from "./routes";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

// Import global styles
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider
      defaultTheme={Theme.SYSTEM}
      storageKey="employee-management-theme"
    >
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ConfirmationDialogProvider>
            <RouterProvider router={router} />
            <Toaster position="top-right" />
          </ConfirmationDialogProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  </React.StrictMode>
);
